export const getNextItemInArray = <T>(array: T[], currentItem: T): T => {
  const currentIndex = array.indexOf(currentItem);
  const nextIndex = currentIndex + 1;
  const nextItem = array[nextIndex];

  if (nextItem !== undefined) {
    return nextItem;
  }

  return array[0];
};

export const getPreviousItemInArray = <T>(array: T[], currentItem: T): T => {
  const currentIndex = array.indexOf(currentItem);
  const previousIndex = currentIndex - 1;
  const previousItem = array[previousIndex];

  if (previousItem !== undefined) {
    return previousItem;
  }

  return array[array.length - 1];
};
